import { React, useEffect, useRef } from "react";
import { Link } from "react-router-dom"
import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
import {useStyle} from '../../context/styleContext/styleContext'
import ReactGA from 'react-ga4';
const GOOGLE_ID = "G-0BG7KPR1E4"



export default function CookieHandler(){

  const consentGiven = getCookieConsentValue("CookieConsent");

  const { style, setStyle } = useStyle();


  if (consentGiven == "true") {
    ReactGA.initialize(GOOGLE_ID)
  }  

  const  accept= () => {

      ReactGA.initialize(GOOGLE_ID)
      
  };
      

  return (  
<>
<CookieConsent
  location="bottom"
  buttonText="Okay"
  acceptOnScroll='true'
  onAccept={(acceptedByScrolling) => {
    if (acceptedByScrolling) {
      // triggered if user scrolls past threshold
    accept();
    //alert("Accept was triggered by user scrolling");
    } else {
    accept();
    //alert("Accept was triggered by clicking the Accept button");
    }
  }}
  //cookieName="myAwesomeCookieName2"
  style={{ background: style.color4, color:style.color1, minHeight:'10%', alignContent:'center'}}
  buttonStyle={{ color: style.color4, fontSize: "16px", fontWeight:'bold', backgroundColor:style.color1 }}
  expires={150}
  
>
  This website uses cookies to enhance the user experience.{" "}
</CookieConsent>


</>
    
  )}

